/**
 * PreviewCanvas — Canvas area with viewport simulation, grid overlay, and preview.
 */
import { useBuilderStore } from '@/state/store';
import { PreviewRoot } from './preview/PreviewRoot';
import { PreviewContentPage } from './preview/PreviewContentPage';
import { GridOverlay } from './preview/GridOverlay';

export function PreviewCanvas() {
  const viewport = useBuilderStore((s) => s.viewport);
  const mode = useBuilderStore((s) => s.mode);
  const showGrid = useBuilderStore((s) => s.showGrid);
  const show8pxRaster = useBuilderStore((s) => s.show8pxRaster);
  const settings = useBuilderStore((s) => s.settings);
  const components = useBuilderStore((s) => s.components);
  const order = useBuilderStore((s) => s.order);
  const previewPage = useBuilderStore((s) => s.previewPage);
  const updateSettings = useBuilderStore((s) => s.updateSettings);

  const toggleDarkMode = () => {
    updateSettings({ ...settings, darkMode: !settings.darkMode });
  };

  return (
    <div className={`sb-canvas canvas--${mode}`}>
      <div className={`preview-frame preview-frame--${viewport}`}>
        {showGrid && <GridOverlay show8px={show8pxRaster} viewport={viewport} />}
        {previewPage === 'index' ? (
          <PreviewRoot
            components={components}
            order={order}
            settings={settings}
            onToggleDarkMode={toggleDarkMode}
          />
        ) : (
          <PreviewContentPage
            page={previewPage}
            settings={settings}
            components={components}
            order={order}
            onToggleDarkMode={toggleDarkMode}
          />
        )}
      </div>
    </div>
  );
}
